import {
  Header1,
  Instruction,
  InstructionWithContent,
} from "../../BlockComponent";
import {
  ButtonGroup,
  GuideTypographyLine,
  LineWithSolidLabel,
  TextareaLine,
  TypographyLine,
} from "../../CellComponent";
import { LastCard } from "../common";

export const Content_11_3_A = [
  Header1("typography_0"),
  Instruction("typography_1"),
  // TODO: src/static/activity/11-3-A/0_ko.png 에 "상황 -> 경험 꾸러미" 이미지 추가 필요. 현재는 mock placeholder.
  // 배포 임시: mock 이미지 주석 처리, text instruction 만 노출
  // InstructionWithImage("typography_2", "0"),
  Instruction("typography_2"),

  Header1("typography_3"),
  Instruction("typography_4"),
  Instruction("typography_5"),

  InstructionWithContent(`typography_6`, [
    [
      ButtonGroup(
        [
          { text: "A. 팀장님이 나를 귀찮아하며 회의를 서둘러 끝냄" },
          { text: "B. 배우자가 어제 저녁에 내 연락을 고의로 무시함" },
          { text: "C. 동료가 약속 시간보다 20분 늦게 도착함" },
        ],
        { id: "quiz1", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz1", answerIndex: 2 }],
    }),
  ]),
  Instruction("typography_7"),

  InstructionWithContent(`typography_8`, [
    [
      ButtonGroup(
        [
          { text: "A. 팀장님이 나를 싫어해서 회의를 10분 만에 끝냄" },
          { text: "B. 팀장님이 손목 시계를 본 뒤 회의를 마침" },
          { text: "C. 팀장님이 피곤한 기색으로 회의실을 나감" },
        ],
        { id: "quiz2", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz2", answerIndex: 1 }],
    }),
  ]),
  Instruction("typography_9"),

  Header1("typography_10"),
  Instruction("typography_11"),

  InstructionWithContent(`typography_12`, [
    ...LineWithSolidLabel("상황 1", TypographyLine("typography_situation_1")),
    ...LineWithSolidLabel("상황 2", TypographyLine("typography_situation_2")),
    ...LineWithSolidLabel("상황 3", TypographyLine("typography_situation_3")),
  ]),
  // TODO: src/static/activity/11-3-A/1_ko.png 에 "{ (상황 -> 경험 꾸러미) x n }" 이미지 추가 필요. 현재는 mock placeholder.
  // 배포 임시: mock 이미지 주석 처리, text instruction 만 노출
  // InstructionWithImage("typography_13", "1"),
  Instruction("typography_13"),

  InstructionWithContent(`typography_14`, [
    [
      ButtonGroup(
        [
          { text: "A. 이번 주 내내 업무가 너무 많아서 야근을 함" },
          { text: "B. 오후 3시 회의에서 내 기획안이 반려됨" },
          { text: "C. 인간관계 때문에 스트레스를 받는 중" },
        ],
        { id: "quiz3", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz3", answerIndex: 1 }],
    }),
  ]),
  Instruction("typography_15"),

  InstructionWithContent(`typography_16`, [
    [
      ButtonGroup(
        [
          {
            text: "A. 오늘 저녁 7시에 부장님이 새로운 보고서를 내일까지 작성하라고 지시함",
          },
          { text: "B. 요즘 들어 회사 일이 나에게만 몰리는 것 같아 억울함" },
          { text: "C. 월요일부터 금요일까지 매일 밤 10시에 퇴근함" },
        ],
        { id: "quiz4", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz4", answerIndex: 0 }],
    }),
  ]),
  Instruction("typography_17"),

  Header1("typography_18"),
  Instruction("typography_19"),
  Instruction("typography_20"),
  Instruction("typography_21"),

  InstructionWithContent(`typography_22`, [
    [
      ButtonGroup(
        [
          { text: "A. 5년 전 친구가 내 비밀을 다른 사람들에게 퍼뜨림" },
          { text: "B. 오늘 아침 출근길에 우연히 그 친구와 닮은 사람을 봄" },
          { text: "C. 그때 친구에게 화를 내지 못한 것을 아직도 후회하고 있음" },
        ],
        { id: "quiz5", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz5", answerIndex: 1 }],
    }),
  ]),
  Instruction("typography_23"),

  Header1("typography_24"),
  Instruction("typography_25"),
  Instruction("typography_26"),
  Instruction("typography_27"),
  Instruction("typography_28"),

  Header1("typography_29"),
  InstructionWithContent(`typography_30`, [
    ...LineWithSolidLabel("원칙 1", TypographyLine("typography_principle_1")),
    ...LineWithSolidLabel("원칙 2", TypographyLine("typography_principle_2")),
    ...LineWithSolidLabel("원칙 3", TypographyLine("typography_principle_3")),
  ]),
  Instruction("typography_31"),

  InstructionWithContent(`typography_32`, [
    ...LineWithSolidLabel("상황", TextareaLine({ id: "상황" })),
  ]),
  Instruction("typography_33"),

  ...LastCard,
];
